/**
 * WCAG 2.1 AA fix for tables: promote the first row's <td> cells
 * to <th scope="col"> so tables have programmatically-defined headers.
 * Preserves original classes, inline styles, and visual appearance.
 *
 * @param {string} html - Raw HTML string containing tables
 * @returns {string} HTML string with first-row <td>s converted to <th scope="col">
 */
export function addTableHeaders(html) {
  if (!html || typeof window === "undefined") return html;
  try {
    const doc = new DOMParser().parseFromString(html, "text/html");
    doc.querySelectorAll("table").forEach((table) => {
      if (table.querySelector("th")) return; // already has headers
      const firstRow = table.querySelector("tr");
      if (!firstRow) return;
      firstRow.querySelectorAll("td").forEach((td) => {
        const th = doc.createElement("th");
        th.setAttribute("scope", "col");
        Array.from(td.attributes).forEach((a) =>
          th.setAttribute(a.name, a.value)
        );
        const existingStyle = th.getAttribute("style") || "";
        th.setAttribute(
          "style",
          `${existingStyle}${existingStyle && !existingStyle.trim().endsWith(";") ? ";" : ""}text-align: inherit;`
        );
        th.innerHTML = td.innerHTML;
        td.replaceWith(th);
      });
    });
    return doc.body.innerHTML;
  } catch (e) {
    console.error("addTableHeaders failed", e);
    return html;
  }
}
